import React, { Component } from 'react';
import { Alert, Collapse, Modal, Row, Col } from 'react-bootstrap';
import { Form, Input } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import Parse from 'parse'

import ReactGA from "react-ga";
import ReactPixel from 'react-facebook-pixel';

import { Center, ImageSection, LogeButton, Icon, Black, ModalHeading } from './GeneralStyle'

import DataPrivDisclaimer from './DataPrivDisclaimer'

import headerImage from '../images/modal/tl_header_bewerbung.jpg';
import successIcon from '../images/icons/tl_check_bewerbung.png'

class ApplyModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAlert: false,
      showModal: this.props.showModal,
      applicationSent: false,
      firstname: null,
      lastname: null
    }
    this.onSubmit = this.onSubmit.bind(this);
    this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  closeModal = () => {
    ReactGA.event({
      category: 'Application',
      action: 'Click',
      label: 'Close Modal'
    });
    this.setState({
      showModal: false,
      applicationSent: false,
      firstname: null,
      lastname: null
    });
  }

  openModal = () => {
    this.setState({ showModal: true });
  }

  onSubmit = (data) => {

    const ApplicationParseObj = Parse.Object.extend("Application")
    let newApplication = new ApplicationParseObj()

    newApplication.set("firstname", data.firstname)
    newApplication.set("title", data.title)
    newApplication.set("lastname", data.lastname)
    newApplication.set("company", data.company)
    newApplication.set("position", data.position)
    newApplication.set("phone", data.countrycode + data.phone)
    newApplication.set("email", data.email)
    newApplication.set("handicap", Number(data.handicap))
    newApplication.set("golfcourse", data.golfcourse)
    newApplication.set("knownMember", data.member)
    newApplication.set("uid", data.uid)
    newApplication.set("industry", data.industry)

    newApplication.save().then(res => {
      ReactGA.event({
        category: 'Application',
        action: 'Sent Application',
        label: 'Sent Application - Success'
      });

      ReactPixel.track('Lead', '');

      this.setState({
        applicationSent: true,
        firstname: data.firstname,
        lastname: data.lastname
      })
    }).catch(error => {
      console.error("ApplicationError:", error)

      ReactGA.event({
        category: 'Application',
        action: 'Click',
        label: 'Sent Application - Failed'
      });
    })
  }

  handleAlertDismiss() {
    this.setState({
      showAlert: false,

    })
  }

  render() {
    const isDefaultRequiredValue = 'Das ist ein Pflichtfeld.'

    const applicationSuccess = (
      <div>
        <Center marginTop={30} marginBottom={30}>
          <Icon icon={successIcon} size={168} margin={0} float={"none"} />
        </Center>
        <Center marginTop={40} marginBottom={30}>
          <Black fontSize={"130%"} display={"inline"}>Vielen Dank für Ihre Bewerbung, </Black>
          <Black fontSize={"130%"} fontWeight={"bold"} display={"inline"}>{this.state.firstname + " " + this.state.lastname}!</Black>
          <Black>Wir melden uns bei Ihnen in Kürze.</Black>
        </Center>
        <Center marginTop={70} marginBottom={30}>
          <LogeButton
            hoverFontColor={"white"}
            onClick={() => { this.closeModal() }}>
            schließen</LogeButton>
        </Center>
      </div>
    )

    const applicationForm = (
      <Form
        onSubmit={this.onSubmit}
        layout={'vertical'}
        validateOnSubmit={true}
        validatePristine={false}
      >
        <Row>
          <Col sm={2} className={"no-side-padding"} style={{ paddingRight: 10 }}>
            <Input
              style={{ marginTop: 5 }}
              name="title"
              value=""
              type="text"
              placeholder="Titel"
            />
          </Col>
          <Col sm={5} className={"no-side-padding"} style={{ paddingRight: 10 }}>
            <Input
              name="firstname"
              value=""
              type="text"
              placeholder="Vorname*"
              validationErrors={{ isDefaultRequiredValue }}
              required
            />
          </Col>
          <Col sm={5} className={"no-side-padding"}>
            <Input
              name="lastname"
              value=""
              type="text"
              validationErrors={{ isDefaultRequiredValue }}
              placeholder="Nachname*"
              required
            />
          </Col>
        </Row>
        <Input
          name="company"
          value=""
          type="text"
          validationErrors={{ isDefaultRequiredValue }}
          placeholder="Unternehmen"
        />
        <Col sm={6} className={"no-side-padding"} style={{ paddingRight: 10 }}>
          <Input
            name="uid"
            value=""
            type="text"
            placeholder="UID"
            validationErrors={{ isDefaultRequiredValue }}
          />
        </Col>
        <Col sm={6} className={"no-side-padding"}>
          <Input
            // style={{ marginTop: 5 }}
            name="industry"
            value=""
            type="text"
            placeholder="Branche"
          />
        </Col>
        <Col sm={12} className={"no-side-padding"}>
          <Input
            name="position"
            value=""
            type="text"
            validationErrors={{ isDefaultRequiredValue }}
            placeholder="Position"
          />
        </Col>
        <Col sm={12} className={"no-side-padding"}>
          <Input
            name="handicap"
            value=""
            type="text"
            placeholder="Handicap"
          />
        </Col>
        <Col sm={12} className={"no-side-padding"}>
          <Input
            name="golfcourse"
            value=""
            type="text"
            placeholder="Golfclub"
          />
        </Col>
        <Col sm={12} className={"no-side-padding"}>
          <Input
            name="member"
            value=""
            type="text"
            validationErrors={{ isDefaultRequiredValue }}
            placeholder="Welches Mitglied kennen Sie bereits?"
          />
        </Col>
        <Col xs={4} className={"no-side-padding"} style={{ paddingRight: 10 }}>
          <Input
            name="countrycode"
            value=""
            type="text"
            validationErrors={{ isDefaultRequiredValue }}
            placeholder="Vorwahl*"
            required
          />
        </Col>
        <Col xs={8} className={"no-side-padding"}>
          <Input
            name="phone"
            value=""
            type="text"
            validationErrors={{ isDefaultRequiredValue }}
            placeholder="Telefonnummer*"
            required
          />
        </Col>
        <Input
          name="email"
          value=""
          type="email"
          validationErrors={{ isDefaultRequiredValue }}
          placeholder="E-Mail Adresse*"
          required
        />
        <DataPrivDisclaimer />
        <Center marginTop={30} marginBottom={30}>
          <LogeButton
            hoverFontColor={"white"}
            type="submit">bewerben</LogeButton></Center>
      </Form>
    )

    return (

      <Modal show={this.state.showModal} onHide={this.closeModal}>
        <ImageSection background={headerImage}>
          <Modal.Header closeButton>
            <Modal.Title>
              <div><ModalHeading>Ihre Bewerbung bei THE LOGE</ModalHeading></div>
            </Modal.Title>
          </Modal.Header>
        </ImageSection>
        <Modal.Body>
          <Collapse in={this.state.showAlert}>
            <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
              <h4>Bewerbung fehlgeschlagen!</h4>
              <p>Die Bewerbung war nicht erfolgreich.</p>
            </Alert>
          </Collapse>

          {!this.state.applicationSent
            ? applicationForm
            : applicationSuccess}
        </Modal.Body>
      </Modal>
    );
  }
}

export default withRouter(ApplyModal)



// WEBPACK FOOTER //
// /src/components/ApplyModal.js